import { useState } from "react";
import { ChevronDown, Expand } from "lucide-react";
import { MOMENTS } from "../data/brochure";
import { Lightbox } from "./Lightbox";

const INITIAL = 9;

export const MomentsOfImpact = () => {
  const [showAll, setShowAll] = useState(false);
  const [index, setIndex] = useState(null);
  const visible = showAll ? MOMENTS : MOMENTS.slice(0, INITIAL);

  return (
    <div className="moments" data-testid="moments-section">
      <div className="moments-head">
        <h3 className="moments-title" data-testid="moments-title">Moments of <span>Impact</span></h3>
        <p>Real people. Real change. Tap any photo to view it larger.</p>
      </div>
      <div className="moments-grid">
        {visible.map((m, i) => (
          <button key={m.src} className="moment-item" onClick={() => setIndex(i)} data-testid={`moment-item-${i}`}>
            <img src={m.src} alt={m.alt} loading="lazy" />
            <span className="moment-zoom"><Expand /></span>
          </button>
        ))}
      </div>
      {!showAll && (
        <button className="btn-secondary moments-more" onClick={() => setShowAll(true)} data-testid="moments-show-all">
          Show All {MOMENTS.length} Moments <ChevronDown className="btn-icon" />
        </button>
      )}
      <Lightbox images={MOMENTS} index={index} onClose={() => setIndex(null)} onChange={setIndex} testId="moments-lightbox" />
    </div>
  );
};
